exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards-accepted-div {\r\n    padding-top: 1px;\r\n}\r\n\r\n.card-img-div {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    width: 30px;\r\n    height: 20px;\r\n}\r\n\r\n.accepted-card-img {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n}", ""]);

// exports
